import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Chip,
  IconButton,
  Button,
  Divider,
} from "@mui/material";
import {
  CheckCircle,
  Warning,
  Info,
  Delete,
  MarkEmailRead,
} from "@mui/icons-material";

const Notifications = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "New Worker Registration",
      message: "John Doe has been registered under ABC Contractor",
      type: "info",
      time: "2 hours ago",
      read: false,
    },
    {
      id: 2,
      title: "Compliance Deadline Approaching",
      message: "Form XV is due in 5 days",
      type: "warning",
      time: "5 hours ago",
      read: false,
    },
    {
      id: 3,
      title: "Daily Attendance Summary",
      message: "Today's attendance: 95% (950/1000)",
      type: "success",
      time: "1 day ago",
      read: true,
    },
  ]);

  const getNotificationIcon = (type) => {
    const icons = {
      success: <CheckCircle sx={{ color: "success.main" }} />,
      warning: <Warning sx={{ color: "warning.main" }} />,
      info: <Info sx={{ color: "info.main" }} />,
    };
    return icons[type] || icons.info;
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, read: true })));
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Notifications
        </Typography>
        <Button startIcon={<MarkEmailRead />} onClick={markAllAsRead}>
          Mark All as Read
        </Button>
      </Box>

      <Card>
        <CardContent>
          <List>
            {notifications.map((notification, index) => (
              <React.Fragment key={notification.id}>
                <ListItem
                  sx={{
                    bgcolor: notification.read ? "transparent" : "action.hover",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemAvatar>
                    <Avatar>{getNotificationIcon(notification.type)}</Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Typography variant="subtitle2">
                          {notification.title}
                        </Typography>
                        {!notification.read && (
                          <Chip label="New" color="primary" size="small" />
                        )}
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          {notification.message}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {notification.time}
                        </Typography>
                      </Box>
                    }
                  />
                  <IconButton size="small">
                    <Delete />
                  </IconButton>
                </ListItem>
                {index < notifications.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Notifications;
